"use client";

import { c as _c } from "react/compiler-runtime";
import { cn } from "@/lib/utils";
export type FeedbackTab = "give" | "yours";

/**
 * The give/yours segmented switch, shared by the sidebar and modal shells (which
 * differ only in horizontal padding). Extracted when the unread badge landed —
 * the two shells already carried byte-identical copies of this markup, and a
 * third piece of conditional content in both was one copy too many.
 */
export function FeedbackTabSwitch(t0) {
  const $ = _c(10);
  const {
    tab,
    onChange,
    unreadCount: t1,
    className
  } = t0;
  const unreadCount = t1 === undefined ? 0 : t1;
  let t2;
  if ($[0] !== className) {
    t2 = cn("flex gap-1 border-b border-gray-100 py-2", className);
    $[0] = className;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = ["give", "yours"];
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== onChange || $[4] !== tab || $[5] !== unreadCount) {
    t4 = (t3 as const).map(t => <button key={t} type="button" onClick={() => onChange(t)} className={cn("flex-1 inline-flex items-center justify-center whitespace-nowrap rounded-lg px-3 py-1.5 text-xs font-medium transition-all", tab === t ? "bg-white text-[#091E42] shadow-[0_2px_8px_rgba(86,81,255,0.15)]" : "text-gray-500 hover:text-gray-700")}>{t === "give" ? "Give feedback" : "Your feedback"}{t === "yours" && unreadCount > 0 && <span aria-label={`${unreadCount} unread`} className="ml-1.5 inline-flex h-4 min-w-4 items-center justify-center rounded-full bg-red-500 px-1 text-[10px] font-semibold leading-none text-white">{unreadCount > 9 ? "9+" : unreadCount}</span>}</button>);
    $[3] = onChange;
    $[4] = tab;
    $[5] = unreadCount;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t2 || $[8] !== t4) {
    t5 = <div className={t2}>{t4}</div>;
    $[7] = t2;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
}